/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { ETransportLocationDTO } from './etransport-location-dto.model';

export class ETransportShipmentDataCollaborationDtoModel extends JSONable {
  eTransportNotificationUuid: string | null = null;
  operationTypeUuid: string | null = null;
  externalReference: string | null = null;
  licensePlate: string | null = null;
  firstTrailerLicensePlate: string | null = null;
  secondTrailerLicensePlate: string | null = null;
  shipmentDate: string | null = null;
  startLocationDTO: ETransportLocationDTO | null = null;
  endLocationDTO: ETransportLocationDTO | null = null;
}
